/** Hebrew UI copy for the embedded Xtram chatbot (RTL-first). */
export const CHATBOT_HE = {
  launcherTooltip: 'תשאל את ה־AI שלנו',
  titleMain: "צ'אט AI פיננסי Xtram",
  titleSub: 'מופעל על ידי Xtram',
  statusActive: 'פעיל',
  ariaCloseChat: "סגור צ'אט",
  ariaExpand: "הרחב את הצ'אט",
  ariaCollapse: "צמצם את הצ'אט",
  uiHeaderTitle: 'עוזר AI של Xtram',
  uiHeaderSub: 'מופעל על ידי Xtram',
  messagePlaceholderCompact: 'הודעה…',
  messagePlaceholderFull: 'כתבו את הודעתכם…',
  hintSend: 'Enter לשליחה • Shift+Enter לשורה חדשה',
  uploading: 'מעלה קובץ…',
  tooltipAttach: (mb) => `העלאת קובץ (עד ${mb} מ״ב)`,
  tooltipSend: 'שליחה',
  voiceRecord: 'הקלטת הודעה קולית',
  voiceSend: 'שליחת הודעה קולית',
  voiceCancel: 'ביטול הקלטה',
  voiceMessageLabel: 'הודעה קולית',
  voiceProcessing: 'מעבדים את ההקלטה…',
  videoTutorialTitle: 'סרטון הדרכה',
  micRequired: 'נדרש אישור גישה למיקרופון להקלטת הודעות קוליות.',
  labelAssistant: 'עוזר',
  labelYou: 'אתם',
  typingDelay: 'כמעט סיימנו… התשובה נמשכת מעט יותר מהרגיל',
  exportPdf: 'ייצוא PDF',
};
